import { useId } from 'react';
import { FIELD_BORDER_CLASSES, FIELD_ERROR_BORDER_CLASSES, FieldErrorMessage, FieldErrorText } from './Input';

const Textarea = ({ label, error, errorMessage, className = '', ...props }) => {
    const generatedId = useId();
    const fieldId = props.id || generatedId;
    const hasError = Boolean(error || errorMessage);
    const errorText = FieldErrorText(error, errorMessage);
    const errorId = `${fieldId}-error`;

    return (
        <div className="w-full">
            {label ? (
                <label htmlFor={fieldId} className="block text-sm font-medium text-mono-700 dark:text-mono-300 mb-1">
                    {label}
                </label>
            ) : null}

            <textarea
                id={fieldId}
                aria-invalid={hasError || undefined}
                aria-describedby={errorText ? errorId : undefined}
                className={`w-full px-4 py-2 text-base border rounded-lg transition-all duration-200 focus:outline-none focus:ring-1
          ${hasError ? FIELD_ERROR_BORDER_CLASSES : FIELD_BORDER_CLASSES}
          bg-white dark:bg-mono-950 text-black dark:text-white placeholder-mono-400 dark:placeholder-mono-600
          disabled:bg-mono-100 dark:disabled:bg-mono-900 disabled:cursor-not-allowed
          ${className}`}
                {...props}
            />

            {errorText ? <FieldErrorMessage id={errorId}>{errorText}</FieldErrorMessage> : null}
        </div>
    );
};

export default Textarea;
